import React, { useContext, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { CSCContext } from "../CSCContext";

function Page(props) {
	let number = props.number;
	if (typeof(number) === "string") {
		number = parseInt(number, 10);
	}
	let isCurrentPage = props.number === useContext(CSCContext).currentPage;

	const pageRef = useRef(null);

	useEffect(() => {
		if (isCurrentPage) {
			pageRef.current.focus();
		}
	}, [isCurrentPage]);

	if (isCurrentPage) {
		return (
			<div 
				id={"page" + props.number}
				ref={pageRef}
				className="csc-page"
				tabIndex="-1"
			>
				{props.children}
			</div>
		);
	}

	return null;
}

Page.propTypes = {
	number: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	])
};

Page.defaultProps = {
	number: 1
};

export default Page;
